import type { IApiRouteResponse } from 'types/common';
import type { TWishlist } from 'types/wishlist';

export interface IResponse extends IApiRouteResponse {
  data: TWishlist;
}

export const fetchCreateWishlist = async (name = 'Default'): Promise<IResponse> => {
  const response = await fetch('/api/wishlist/create', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });

  return response.json();
};
